/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.ts to modify the generation of this file.

import dynamic from 'next/dynamic'


import * as HeadLink from 'src/components/advanced/HeadLink/HeadLink';
import * as HeadScript from 'src/components/advanced/HeadScript/HeadScript';
import * as JobDetails from 'src/components/affiliate/JobDetails/JobDetails';
import * as JobGuidedSearch from 'src/components/affiliate/JobGuidedSearch/JobGuidedSearch';
import * as JobMiniSearch from 'src/components/affiliate/JobMiniSearch/JobMiniSearch';
import * as JobOverview from 'src/components/affiliate/JobOverview/JobOverview';
import * as JobSearch from 'src/components/affiliate/JobSearch/JobSearch';
import * as ShowroomAddressAndHours from 'src/components/affiliate/ShowroomAddressAndHours/ShowroomAddressAndHours';
import * as ARProductCard from 'src/components/card/ARProductCard/ARProductCard';
import * as ButtonCard from 'src/components/card/ButtonCard/ButtonCard';
import * as CardImageAndProductDetails from 'src/components/card/CardImageAndProductDetails/CardImageAndProductDetails';
import * as CardOffer from 'src/components/card/CardOffer/CardOffer';
import * as GenericCard from 'src/components/card/GenericCard/GenericCard';
import * as ProductMediaCard from 'src/components/card/ProductMediaCard/ProductMediaCard';
import * as ProductPreviewCard from 'src/components/card/ProductPreviewCard/ProductPreviewCard';
import * as ConsultationRequest from 'src/components/forms/ConsultationRequest/ConsultationRequest';
const ContactUs = {
  module: () => import('src/components/forms/ContactUs/ContactUs.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/forms/ContactUs/ContactUs.dynamic')?.default : dynamic(ContactUs.module)
}
import * as EnewsSignUpBanner from 'src/components/forms/EnewsSignUpBanner/EnewsSignUpBanner';
import * as Form from 'src/components/forms/Form/Form';
import * as FormContainer from 'src/components/forms/FormContainer/FormContainer';
import * as FormWithCardPlaceholder from 'src/components/forms/FormWithCardPlaceholder/FormWithCardPlaceholder';
import * as FormWithContentBlock from 'src/components/forms/FormWithContentBlock/FormWithContentBlock';
const JobApplicant = {
  module: () => import('src/components/forms/JobApplicant/JobApplicant.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/forms/JobApplicant/JobApplicant.dynamic')?.default : dynamic(JobApplicant.module)
}
import * as JobDetailsFormContainer from 'src/components/forms/JobDetailsFormContainer/JobDetailsFormContainer';
import * as OnlineScheduling from 'src/components/forms/OnlineScheduling/OnlineScheduling';
const RbaConsultRequestForm = {
  module: () => import('src/components/forms/RbAConsultRequestForm/RbaConsultRequestForm.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/forms/RbAConsultRequestForm/RbaConsultRequestForm.dynamic')?.default : dynamic(RbaConsultRequestForm.module)
}
import * as CardHelper from 'src/components/forms/RequestQuote/CardHelper';
const RequestQuote = {
  module: () => import('src/components/forms/RequestQuote/RequestQuote.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/forms/RequestQuote/RequestQuote.dynamic')?.default : dynamic(RequestQuote.module)
}
const SelectionGuideSignUp = {
  module: () => import('src/components/forms/SelectionGuideSignUp/SelectionGuideSignUp.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/forms/SelectionGuideSignUp/SelectionGuideSignUp.dynamic')?.default : dynamic(SelectionGuideSignUp.module)
}
import * as StickyBannerFormContainer from 'src/components/forms/StickyBannerFormContainer/StickyBannerFormContainer';
import * as StickyHeaderForm from 'src/components/forms/StickyHeaderForm/StickyHeaderForm';
const VenturesPartner = {
  module: () => import('src/components/forms/VenturesPartner/VenturesPartner.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/forms/VenturesPartner/VenturesPartner.dynamic')?.default : dynamic(VenturesPartner.module)
}
const WarrantyRegistration = {
  module: () => import('src/components/forms/WarrantyRegistration/WarrantyRegistration.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/forms/WarrantyRegistration/WarrantyRegistration.dynamic')?.default : dynamic(WarrantyRegistration.module)
}
import * as BazaarvoiceQuestionAnswer from 'src/components/general/BazaarvoiceQuestionAnswer/BazaarvoiceQuestionAnswer';
const BazaarvoiceReviewSubmission = {
  module: () => import('src/components/general/BazaarvoiceReviewSubmission/BazaarvoiceReviewSubmission.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/general/BazaarvoiceReviewSubmission/BazaarvoiceReviewSubmission.dynamic')?.default : dynamic(BazaarvoiceReviewSubmission.module)
}
import * as BazaarvoiceReviews from 'src/components/general/BazaarvoiceReviews/BazaarvoiceReviews';
import * as BlogQuote from 'src/components/general/BlogQuote/BlogQuote';
import * as BottomStickyTab from 'src/components/general/BottomStickyTab/BottomStickyTab';
import * as Carousel from 'src/components/general/Carousel/Carousel';
import * as ChatButton from 'src/components/general/ChatButton/ChatButton';
import * as chatbuttonstore from 'src/components/general/ChatButton/chatbutton.store';
import * as ContentBlock from 'src/components/general/ContentBlock/ContentBlock';
import * as ContentBlockWithMedia from 'src/components/general/ContentBlockWithMedia/ContentBlockWithMedia';
import * as ContentBlockWithMediaAW from 'src/components/general/ContentBlockWithMedia/ContentBlockWithMediaAW';
import * as ContentBlockWithMediaRba from 'src/components/general/ContentBlockWithMedia/ContentBlockWithMediaRba';
import * as ContentBlockWithMediaAndProduct from 'src/components/general/ContentBlockWithMediaAndProduct/ContentBlockWithMediaAndProduct';
import * as ContentBlockWithSidebar from 'src/components/general/ContentBlockWithSidebar/ContentBlockWithSidebar';
const CookieConsent = {
  module: () => import('src/components/general/CookieConsent/CookieConsent.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/general/CookieConsent/CookieConsent.dynamic')?.default : dynamic(CookieConsent.module)
}
import * as CuratedImageDisplay from 'src/components/general/CuratedImageDisplay/CuratedImageDisplay';
import * as FreeStandingCta from 'src/components/general/FreeStandingCta/FreeStandingCta';
import * as GalleryWithFeaturedImage from 'src/components/general/GalleryWithFeaturedImage/GalleryWithFeaturedImage';
import * as GenericChart from 'src/components/general/GenericChart/GenericChart';
import * as GlobalMasthead from 'src/components/general/GlobalMasthead/GlobalMasthead';
const HTMLBlock = {
  module: () => import('src/components/general/HTMLBlock/HTMLBlock.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/general/HTMLBlock/HTMLBlock.dynamic')?.default : dynamic(HTMLBlock.module)
}
import * as HeadlineRevolvingCTA from 'src/components/general/HeadlineRevolvingCTA/HeadlineRevolvingCTA';
import * as HeadlineWithNavigation from 'src/components/general/HeadlineWithNavigation/HeadlineWithNavigation';
import * as HelpfulLinks from 'src/components/general/HelpfulLinks/HelpfulLinks';
const Iframe = {
  module: () => import('src/components/general/Iframe/Iframe.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/general/Iframe/Iframe.dynamic')?.default : dynamic(Iframe.module)
}
import * as ImageCarousel from 'src/components/general/ImageCarousel/ImageCarousel';
import * as MetaLocator from 'src/components/general/MetaLocator/MetaLocator';
import * as PageMashup from 'src/components/general/PageMashup/PageMashup';
import * as RbAConsultRequest from 'src/components/general/RbAConsultRequest/RbAConsultRequest';
import * as RbAConsultRequestCanada from 'src/components/general/RbAConsultRequestCanada/RbAConsultRequestCanada';
import * as SectionHeadline from 'src/components/general/SectionHeadline/SectionHeadline';
import * as SocialImageCarousel from 'src/components/general/SocialImageCarousel/SocialImageCarousel';
import * as StickyBanner from 'src/components/general/StickyBanner/StickyBanner';
import * as SwatchCollection from 'src/components/general/SwatchCollection/SwatchCollection';
import * as ToggleBanner from 'src/components/general/ToggleBanner/ToggleBanner';
import * as ToggleBannerHelper from 'src/components/general/ToggleBanner/ToggleBannerHelper';
import * as TwoColumnHeadline from 'src/components/general/TwoColumnHeadline/TwoColumnHeadline';
import * as VideoGallery from 'src/components/general/VideoGallery/VideoGallery';
import * as VideoGalleryDynamic from 'src/components/general/VideoGalleryDynamic/VideoGalleryDynamic';
import * as HeroBlogArticle from 'src/components/hero/HeroBlogArticle/HeroBlogArticle';
import * as HeroFeaturedProduct from 'src/components/hero/HeroFeaturedProduct/HeroFeaturedProduct';
import * as HeroHalfMedia from 'src/components/hero/HeroHalfMedia/HeroHalfMedia';
import * as HeroMediaBackground from 'src/components/hero/HeroMediaBackground/HeroMediaBackground';
import * as HeroNavigationWithContainer from 'src/components/hero/HeroNavigationWithContainer/HeroNavigationWithContainer';
import * as HeroOffer from 'src/components/hero/HeroOffer/HeroOffer';
import * as HeroProductTabs from 'src/components/hero/HeroProductTabs/HeroProductTabs';
import * as HeroSimple from 'src/components/hero/HeroSimple/HeroSimple';
import * as HeroTwoColumn from 'src/components/hero/HeroTwoColumn/HeroTwoColumn';
import * as HeroWithFormFill from 'src/components/hero/HeroWithFormFill/HeroWithFormFill';
import * as HeroWithNavigation from 'src/components/hero/HeroWithNavigation/HeroWithNavigation';
const FavoriteDesigns = {
  module: () => import('src/components/listing/FavoriteDesigns/FavoriteDesigns.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/listing/FavoriteDesigns/FavoriteDesigns.dynamic')?.default : dynamic(FavoriteDesigns.module)
}
const FavoriteProducts = {
  module: () => import('src/components/listing/FavoriteProducts/FavoriteProducts.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/listing/FavoriteProducts/FavoriteProducts.dynamic')?.default : dynamic(FavoriteProducts.module)
}
import * as ListHighlightAndCta from 'src/components/listing/ListHighlightAndCta/ListHighlightAndCta';
import * as ListImageWithCallouts from 'src/components/listing/ListImageWithCallouts/ListImageWithCallouts';
const RecentlyViewedDocuments = {
  module: () => import('src/components/listing/RecentlyViewedDocuments/RecentlyViewedDocuments.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/listing/RecentlyViewedDocuments/RecentlyViewedDocuments.dynamic')?.default : dynamic(RecentlyViewedDocuments.module)
}
import * as XupCardCollection from 'src/components/listing/XupCardCollection/XupCardCollection';
import * as XupCardCollectionDynamic from 'src/components/listing/XupCardCollectionDynamic/XupCardCollectionDynamic';
import * as GenericModal from 'src/components/modal/GenericModal/GenericModal';
import * as PopUpModal from 'src/components/modal/PopUpModal/PopUpModal';
import * as VideoModal from 'src/components/modal/VideoModal/VideoModal';
import * as ArticleTags from 'src/components/pages/ArticleTags/ArticleTags';
import * as ComparisonTableProducts from 'src/components/product/ComparisonTableProducts/ComparisonTableProducts';
import * as ComparisonTableSeries from 'src/components/product/ComparisonTableSeries/ComparisonTableSeries';
import * as ProductCarousel from 'src/components/product/ProductCarousel/ProductCarousel';
import * as ProductIntro from 'src/components/product/ProductIntro/ProductIntro';
import * as ProductVisualizer from 'src/components/product/ProductVisualizer/ProductVisualizer';
import * as ThreekitVisualizer from 'src/components/product/ThreekitVisualizer/ThreekitVisualizer';
import * as PromoBannerAuthored from 'src/components/promo/PromoBannerAuthored/PromoBannerAuthored';
import * as PromoFeaturedMedia from 'src/components/promo/PromoFeaturedMedia/PromoFeaturedMedia';
import * as PromoFlipsnackViewer from 'src/components/promo/PromoFlipsnackViewer/PromoFlipsnackViewer';
import * as PromoGeneric from 'src/components/promo/PromoGeneric/PromoGeneric';
import * as PromoImageGrid from 'src/components/promo/PromoImageGrid/PromoImageGrid';
import * as PromoImageWithSlider from 'src/components/promo/PromoImageWithSlider/PromoImageWithSlider';
import * as PromoMediaBackground from 'src/components/promo/PromoMediaBackground/PromoMediaBackground';
import * as PromoReviewContentAuthored from 'src/components/promo/PromoReviewContentAuthored/PromoReviewContentAuthored';
import * as PromoSwatches from 'src/components/promo/PromoSwatches/PromoSwatches';
import * as TabsFeaturedPromo from 'src/components/promo/TabsFeaturedPromo/TabsFeaturedPromo';
import * as CarouselDynamicReviews from 'src/components/reviews/CarouselDynamicReviews/CarouselDynamicReviews';
import * as ProjectCountAndReviewAggregate from 'src/components/reviews/ProjectCountAndReviewAggregate/ProjectCountAndReviewAggregate';
import * as ReputationReviewsWidget from 'src/components/reviews/ReputationReviewsWidget/ReputationReviewsWidget';
import * as ReviewSummary from 'src/components/reviews/ReviewSummary/ReviewSummary';
import * as reviewsummarystore from 'src/components/reviews/ReviewSummary/reviewsummary.store';
import * as PageMashupDynamic from 'src/components/search/PageMashupDynamic/PageMashupDynamic';
import * as Search from 'src/components/search/Search/Search';
import * as OrganizationSchema from 'src/components/seo/OrganizationSchema/OrganizationSchema';
import * as ProductSchema from 'src/components/seo/ProductSchema/ProductSchema';
import * as WebsiteSchema from 'src/components/seo/WebsiteSchema/WebsiteSchema';
import * as AWFooter from 'src/components/site/AWFooter/AWFooter';
import * as AWHeader from 'src/components/site/AWHeader/AWHeader';
import * as Breadcrumb from 'src/components/site/Breadcrumb/Breadcrumb';
import * as EnewsHeader from 'src/components/site/EnewsHeader/EnewsHeader';
import * as NavigationWithIcons from 'src/components/site/NavigationWithIcons/NavigationWithIcons';
import * as RaqMobileBanner from 'src/components/site/RaqMobileBanner/RaqMobileBanner';
import * as RbAFooter from 'src/components/site/RbAFooter/RbAFooter';
import * as RbAHeader from 'src/components/site/RbAHeader/RbAHeader';
import * as TAFooter from 'src/components/site/TAFooter/TAFooter';
import * as TAHeader from 'src/components/site/TAHeader/TAHeader';
import * as ErrorBoundary from 'src/components/system/ErrorBoundary';
const EmptySharedChildDataSource = {
  module: () => import('src/components/system/EmptySharedChildDataSource/EmptySharedChildDataSource.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/system/EmptySharedChildDataSource/EmptySharedChildDataSource.dynamic')?.default : dynamic(EmptySharedChildDataSource.module)
}
const SystemError = {
  module: () => import('src/components/system/SystemError/SystemError.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/system/SystemError/SystemError.dynamic')?.default : dynamic(SystemError.module)
}
import * as Accordion from 'src/components/tabs/Accordion/Accordion';
import * as BlogContainer from 'src/components/tabs/BlogContainer/BlogContainer';
import * as TabsGeneralContent from 'src/components/tabs/TabsGeneralContent/TabsGeneralContent';
import * as AWProductConfigurator from 'src/components/tool/AWProductConfigurator/AWProductConfigurator';
import * as StepsBar from 'src/components/tool/AWProductConfigurator/StepsBar';
import * as constants from 'src/components/tool/AWProductConfigurator/constants';
import * as project from 'src/components/tool/AWProductConfigurator/Helpers/project';
import * as questions from 'src/components/tool/AWProductConfigurator/Helpers/questions';
import * as stepNavigation from 'src/components/tool/AWProductConfigurator/Helpers/stepNavigation';
import * as summary from 'src/components/tool/AWProductConfigurator/Helpers/summary';
import * as threekitUtils from 'src/components/tool/AWProductConfigurator/Helpers/threekitUtils';
import * as tokenUtil from 'src/components/tool/AWProductConfigurator/Helpers/tokenUtil';
import * as activeStepData from 'src/components/tool/AWProductConfigurator/Types/activeStepData';
import * as productlist from 'src/components/tool/AWProductConfigurator/Types/product-list';
import * as productstate from 'src/components/tool/AWProductConfigurator/Types/product-state';
import * as step from 'src/components/tool/AWProductConfigurator/Types/step';
import * as summarysteps from 'src/components/tool/AWProductConfigurator/Types/summary-steps';
import * as threekitConfiguration from 'src/components/tool/AWProductConfigurator/Types/threekitConfiguration';
import * as DesignTool from 'src/components/tool/DesignTool/DesignTool';
import * as renoworkscontext from 'src/components/tool/DesignTool/js/renoworks-context';
const ESeriesSizingCalculator = {
  module: () => import('src/components/tool/E-SeriesSizingCalculator/ESeriesSizingCalculator.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/tool/E-SeriesSizingCalculator/ESeriesSizingCalculator.dynamic')?.default : dynamic(ESeriesSizingCalculator.module)
}
const FoldingDoorSizingCalculator = {
  module: () => import('src/components/tool/FoldingDoorSizingCalculator/FoldingDoorSizingCalculator.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/tool/FoldingDoorSizingCalculator/FoldingDoorSizingCalculator.dynamic')?.default : dynamic(FoldingDoorSizingCalculator.module)
}
const MultiGlideSizingCalculator = {
  module: () => import('src/components/tool/MultiGlideSizingCalculator/MultiGlideSizingCalculator.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/tool/MultiGlideSizingCalculator/MultiGlideSizingCalculator.dynamic')?.default : dynamic(MultiGlideSizingCalculator.module)
}
const MultiSlideSizingCalculator = {
  module: () => import('src/components/tool/MultiSlideSizingCalculator/MultiSlideSizingCalculator.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/tool/MultiSlideSizingCalculator/MultiSlideSizingCalculator.dynamic')?.default : dynamic(MultiSlideSizingCalculator.module)
}
import * as PerfectMatch from 'src/components/tool/PerfectMatch/PerfectMatch';
import * as ProductDesignTool from 'src/components/tool/ProductDesignTool/ProductDesignTool';
import * as ProductDiscovery from 'src/components/tool/ProductDiscovery/ProductDiscovery';
import * as SizingTool from 'src/components/tool/SizingTool/SizingTool';
import * as StormDoorChooseTool from 'src/components/tool/StormDoorChooseTool/StormDoorChooseTool';
import * as TechDocChatBot from 'src/components/tool/TechDocChatBot/TechDocChatBot';

const components = new Map();

components.set('HeadLink', HeadLink);
components.set('HeadScript', HeadScript);
components.set('JobDetails', JobDetails);
components.set('JobGuidedSearch', JobGuidedSearch);
components.set('JobMiniSearch', JobMiniSearch);
components.set('JobOverview', JobOverview);
components.set('JobSearch', JobSearch);
components.set('ShowroomAddressAndHours', ShowroomAddressAndHours);
components.set('ARProductCard', ARProductCard);
components.set('ButtonCard', ButtonCard);
components.set('CardImageAndProductDetails', CardImageAndProductDetails);
components.set('CardOffer', CardOffer);
components.set('GenericCard', GenericCard);
components.set('ProductMediaCard', ProductMediaCard);
components.set('ProductPreviewCard', ProductPreviewCard);
components.set('ConsultationRequest', ConsultationRequest);
components.set('ContactUs', ContactUs);
components.set('EnewsSignUpBanner', EnewsSignUpBanner);
components.set('Form', Form);
components.set('FormContainer', FormContainer);
components.set('FormWithCardPlaceholder', FormWithCardPlaceholder);
components.set('FormWithContentBlock', FormWithContentBlock);
components.set('JobApplicant', JobApplicant);
components.set('JobDetailsFormContainer', JobDetailsFormContainer);
components.set('OnlineScheduling', OnlineScheduling);
components.set('RbaConsultRequestForm', RbaConsultRequestForm);
components.set('CardHelper', CardHelper);
components.set('RequestQuote', RequestQuote);
components.set('SelectionGuideSignUp', SelectionGuideSignUp);
components.set('StickyBannerFormContainer', StickyBannerFormContainer);
components.set('StickyHeaderForm', StickyHeaderForm);
components.set('VenturesPartner', VenturesPartner);
components.set('WarrantyRegistration', WarrantyRegistration);
components.set('BazaarvoiceQuestionAnswer', BazaarvoiceQuestionAnswer);
components.set('BazaarvoiceReviewSubmission', BazaarvoiceReviewSubmission);
components.set('BazaarvoiceReviews', BazaarvoiceReviews);
components.set('BlogQuote', BlogQuote);
components.set('BottomStickyTab', BottomStickyTab);
components.set('Carousel', Carousel);
components.set('ChatButton', ChatButton);
components.set('chatbutton.store', chatbuttonstore);
components.set('ContentBlock', ContentBlock);
components.set('ContentBlockWithMedia', ContentBlockWithMedia);
components.set('ContentBlockWithMediaAW', ContentBlockWithMediaAW);
components.set('ContentBlockWithMediaRba', ContentBlockWithMediaRba);
components.set('ContentBlockWithMediaAndProduct', ContentBlockWithMediaAndProduct);
components.set('ContentBlockWithSidebar', ContentBlockWithSidebar);
components.set('CookieConsent', CookieConsent);
components.set('CuratedImageDisplay', CuratedImageDisplay);
components.set('FreeStandingCta', FreeStandingCta);
components.set('GalleryWithFeaturedImage', GalleryWithFeaturedImage);
components.set('GenericChart', GenericChart);
components.set('GlobalMasthead', GlobalMasthead);
components.set('HTMLBlock', HTMLBlock);
components.set('HeadlineRevolvingCTA', HeadlineRevolvingCTA);
components.set('HeadlineWithNavigation', HeadlineWithNavigation);
components.set('HelpfulLinks', HelpfulLinks);
components.set('Iframe', Iframe);
components.set('ImageCarousel', ImageCarousel);
components.set('MetaLocator', MetaLocator);
components.set('PageMashup', PageMashup);
components.set('RbAConsultRequest', RbAConsultRequest);
components.set('RbAConsultRequestCanada', RbAConsultRequestCanada);
components.set('SectionHeadline', SectionHeadline);
components.set('SocialImageCarousel', SocialImageCarousel);
components.set('StickyBanner', StickyBanner);
components.set('SwatchCollection', SwatchCollection);
components.set('ToggleBanner', ToggleBanner);
components.set('ToggleBannerHelper', ToggleBannerHelper);
components.set('TwoColumnHeadline', TwoColumnHeadline);
components.set('VideoGallery', VideoGallery);
components.set('VideoGalleryDynamic', VideoGalleryDynamic);
components.set('HeroBlogArticle', HeroBlogArticle);
components.set('HeroFeaturedProduct', HeroFeaturedProduct);
components.set('HeroHalfMedia', HeroHalfMedia);
components.set('HeroMediaBackground', HeroMediaBackground);
components.set('HeroNavigationWithContainer', HeroNavigationWithContainer);
components.set('HeroOffer', HeroOffer);
components.set('HeroProductTabs', HeroProductTabs);
components.set('HeroSimple', HeroSimple);
components.set('HeroTwoColumn', HeroTwoColumn);
components.set('HeroWithFormFill', HeroWithFormFill);
components.set('HeroWithNavigation', HeroWithNavigation);
components.set('FavoriteDesigns', FavoriteDesigns);
components.set('FavoriteProducts', FavoriteProducts);
components.set('ListHighlightAndCta', ListHighlightAndCta);
components.set('ListImageWithCallouts', ListImageWithCallouts);
components.set('RecentlyViewedDocuments', RecentlyViewedDocuments);
components.set('XupCardCollection', XupCardCollection);
components.set('XupCardCollectionDynamic', XupCardCollectionDynamic);
components.set('GenericModal', GenericModal);
components.set('PopUpModal', PopUpModal);
components.set('VideoModal', VideoModal);
components.set('ArticleTags', ArticleTags);
components.set('ComparisonTableProducts', ComparisonTableProducts);
components.set('ComparisonTableSeries', ComparisonTableSeries);
components.set('ProductCarousel', ProductCarousel);
components.set('ProductIntro', ProductIntro);
components.set('ProductVisualizer', ProductVisualizer);
components.set('ThreekitVisualizer', ThreekitVisualizer);
components.set('PromoBannerAuthored', PromoBannerAuthored);
components.set('PromoFeaturedMedia', PromoFeaturedMedia);
components.set('PromoFlipsnackViewer', PromoFlipsnackViewer);
components.set('PromoGeneric', PromoGeneric);
components.set('PromoImageGrid', PromoImageGrid);
components.set('PromoImageWithSlider', PromoImageWithSlider);
components.set('PromoMediaBackground', PromoMediaBackground);
components.set('PromoReviewContentAuthored', PromoReviewContentAuthored);
components.set('PromoSwatches', PromoSwatches);
components.set('TabsFeaturedPromo', TabsFeaturedPromo);
components.set('CarouselDynamicReviews', CarouselDynamicReviews);
components.set('ProjectCountAndReviewAggregate', ProjectCountAndReviewAggregate);
components.set('ReputationReviewsWidget', ReputationReviewsWidget);
components.set('ReviewSummary', ReviewSummary);
components.set('reviewsummary.store', reviewsummarystore);
components.set('PageMashupDynamic', PageMashupDynamic);
components.set('Search', Search);
components.set('OrganizationSchema', OrganizationSchema);
components.set('ProductSchema', ProductSchema);
components.set('WebsiteSchema', WebsiteSchema);
components.set('AWFooter', AWFooter);
components.set('AWHeader', AWHeader);
components.set('Breadcrumb', Breadcrumb);
components.set('EnewsHeader', EnewsHeader);
components.set('NavigationWithIcons', NavigationWithIcons);
components.set('RaqMobileBanner', RaqMobileBanner);
components.set('RbAFooter', RbAFooter);
components.set('RbAHeader', RbAHeader);
components.set('TAFooter', TAFooter);
components.set('TAHeader', TAHeader);
components.set('ErrorBoundary', ErrorBoundary);
components.set('EmptySharedChildDataSource', EmptySharedChildDataSource);
components.set('SystemError', SystemError);
components.set('Accordion', Accordion);
components.set('BlogContainer', BlogContainer);
components.set('TabsGeneralContent', TabsGeneralContent);
components.set('AWProductConfigurator', AWProductConfigurator);
components.set('StepsBar', StepsBar);
components.set('constants', constants);
components.set('project', project);
components.set('questions', questions);
components.set('stepNavigation', stepNavigation);
components.set('summary', summary);
components.set('threekitUtils', threekitUtils);
components.set('tokenUtil', tokenUtil);
components.set('activeStepData', activeStepData);
components.set('product-list', productlist);
components.set('product-state', productstate);
components.set('step', step);
components.set('summary-steps', summarysteps);
components.set('threekitConfiguration', threekitConfiguration);
components.set('DesignTool', DesignTool);
components.set('renoworks-context', renoworkscontext);
components.set('ESeriesSizingCalculator', ESeriesSizingCalculator);
components.set('FoldingDoorSizingCalculator', FoldingDoorSizingCalculator);
components.set('MultiGlideSizingCalculator', MultiGlideSizingCalculator);
components.set('MultiSlideSizingCalculator', MultiSlideSizingCalculator);
components.set('PerfectMatch', PerfectMatch);
components.set('ProductDesignTool', ProductDesignTool);
components.set('ProductDiscovery', ProductDiscovery);
components.set('SizingTool', SizingTool);
components.set('StormDoorChooseTool', StormDoorChooseTool);
components.set('TechDocChatBot', TechDocChatBot);

// Next.js 'dynamic' import and JavaScript 'dynamic' import are different.
// Next.js 'dynamic(...)' returns common 'React.ComponentType' while
// 'import('...')' returns 'Promise' that will resolve module.
// componentModule uses 'import(...)' because primary usage of it to get not only 'React Component' (default export) but all named exports.
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#dynamic_imports
// componentFactory uses 'dynamic(...)' because primary usage of it to render 'React Component' (default export).
// See https://nextjs.org/docs/advanced-features/dynamic-import
// At the end you will have single preloaded script for each lazy loading module.
// Editing mode doesn't work well with dynamic components in nextjs: dynamic components are not displayed without refresh after a rendering is added. 
// This happens beacuse Sitecore editors simply insert updated HTML generated on server side. This conflicts with nextjs dynamic logic as no HTML gets rendered for dynamic component
// So we use require() to obtain dynamic components in editing mode while preserving dynamic logic for non-editing scenarios
// As we need to be able to seamlessly work with dynamic components in both editing and normal modes, different componentFactory functions will be passed to app

export function componentModule(componentName: string) {
  const component = components.get(componentName);

  // check that component is lazy loading module
  if (!component?.default && component?.module) {
    // return js dynamic import
    return component.module();
  }

  return component;
}

function baseComponentFactory(componentName: string, exportName?: string, isEditing?: boolean) {
  const component = components.get(componentName);

  // check that component should be dynamically imported
  if (component?.element) {
    // return next.js dynamic import
    return component.element(isEditing);
  }

  if (exportName) {
    return component[exportName];
  }

  return component?.Default || component?.default || component;
}
  
export function componentFactory(componentName: string, exportName?: string) {
  return baseComponentFactory(componentName, exportName, false);
}

export function editingComponentFactory(componentName: string, exportName?: string) {
  return baseComponentFactory(componentName, exportName, true);
}
